import React, { useRef, useImperativeHandle, useCallback } from 'react';

import PropTypes from 'prop-types';

import { Modal } from '~/components';
import { t } from '~/helpers';

import FormTransfer from './form';

const Transfer = React.forwardRef((props, ref) => {
  const modalRef = useRef(null);

  const { update, filter } = props;

  const handleToggleModal = useCallback((data) => {
    modalRef.current.handleOpenModal({ data });
  }, []);

  const handleUpdateRecords = useCallback(() => {
    update(filter);
    modalRef.current.handleCloseModal();
  }, [filter]);

  useImperativeHandle(ref, () => ({
    handleToggleModal,
  }));

  return (
    <Modal
      form
      disableBackdropClick
      disableEscapeKeyDown
      ref={modalRef}
      title={t('s.operacao.vazaonaoautorizada.transformartransferencia')}
      component={FormTransfer}
      maxWidth="sm"
      fullScreen={window.innerWidth <= 450}
      onForm={handleUpdateRecords}
    />
  );
});

Transfer.propTypes = {
  update: PropTypes.func.isRequired,
  filter: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Transfer;
